module.exports = __webpack_public_path__ + "static/media/pr.18984bf1.jpg";